export const initialUploadPdfState = {
    form: {
        id: null,
        file: null,
    },
    currentUploadFileForm: null,
    loading: false,
};
const UploadPdf = {
    namespaced: true,
    state: {
        form: initialUploadPdfState.form,
        currentUploadFileForm: initialUploadPdfState.currentUploadFileForm,
        loading: initialUploadPdfState.loading,
    },
    mutations: {
        SET_FORM(state, form) {
            _.set(state, 'form', form);
        },
        SET_CURRENT_UPLOAD_FILE_FORM(state, current) {
            _.set(state, 'currentUploadFileForm', current);
        },
        SET_FORM_PROPERTY(state, data) {
            _.set(state, data.property, data.value);
        },
        SET_LOADING(state, loading) {
            _.set(state, 'loading', loading);
        },
    },
    actions: {
        setLoading({ commit }, loading) {
            commit('SET_LOADING', loading);
        },
        updateProperty({ commit }, data) {
            commit('SET_FORM_PROPERTY', data);
        },
        setForm({ commit }, form) {
            commit('SET_FORM', form);
        },
        setFormType({ commit }, type) {
            commit('SET_CURRENT_UPLOAD_FILE_FORM', type);
        },
    },
};
export default UploadPdf;
